<template>
    <div class="root d-inline-block">

        <button class="btn btn-success iconed btn-block" @click="btnClicked">
            <i class="fa fa-search"></i>
            <span>جستجو</span>
        </button>

    </div>
</template>

<script>
    import BaseService from '../_framework/api/BaseService.js';
    import Utils from '../_framework/utils/Utils.js';

    export default {
        name: 'person-modal-button',
        props: {
            params: {
                mode: 'view'
            }
        },
        data() {
            return {
            };
        },
        methods: {
            btnClicked() {
                this.$emit('toggleSearchRow');
            },
        }
    }
</script>